var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "page-container container" }, [
    _c("div", { staticClass: "page-content-wrapper" }, [
      _c("div", { staticClass: "copyright-text" }, [
        _c("h2", [_vm._v("Datenschutzhinweise der YellowMap AG")]),
        _vm._v(" "),
        _c("h3", [_vm._v("\n\t\t\t\t1.\tDatenschutz auf einen Blick\n\t\t\t")]),
        _vm._v(" "),
        _c("b", [_vm._v("\n\t\t\t\tAllgemeine Hinweise\n\t\t\t")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\nDie folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("b", [_vm._v("\n\t\t\t\tDas Wichtigste im Überblick\n\t\t\t")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n\t\t\t\tIm der folgenden Datenschutzerklärung werden die hier als Überblick aufgelistete Punkte umfassend erläutert. Sofern Sie Fragen zu den Punkten haben, lesen Sie bitte die vollständige Datenschutzerklärung.\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("b", [
          _vm._v("\n\t\t\t\t Datenerfassung auf dieser Website\n\t\t\t")
        ]),
        _vm._v(" "),
        _c("b", [
          _vm._v(
            "\n\t\t\t\tWer ist verantwortlich für die Datenerfassung auf dieser Website?\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n\t\t\t\tDie Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("b", [_vm._v("\n\t\t\t\tWie erfassen wir Ihre Daten?\n\t\t\t")]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("b", [_vm._v("\n\t\t\t\tWofür nutzen wir Ihre Daten?\n\t\t\t")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n\t\t\t\tEin Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("b", [
          _vm._v(
            "\n\t\t\t\tWelche Rechte haben Sie bezüglich Ihrer Daten?\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("b", [_vm._v("\n\t\t\t\tAnalyse-Tools\n\t\t\t")]),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _c("h3", [
          _vm._v(
            "\n\t\t\t\t2.\tAllgemeine Hinweise und Pflichtinformationen\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("b", [_vm._v("\n\t\t\t\tDatenschutz\n\t\t\t")]),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _c("b", [
          _vm._v("\n\t\t\t\tHinweis zur verantwortlichen Stelle\n\t\t\t")
        ]),
        _vm._v(" "),
        _vm._m(6),
        _vm._m(7),
        _vm._v(
          "\n\t\t\t\tVerantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet, vertreten durch die Vorstände Martin Hubschneider.\n\t\t\t"
        ),
        _c("p"),
        _vm._v(" "),
        _c("b", [_vm._v("\n\t\t\t\tSpeicherdauer\n\t\t\t")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n\t\t\t\tSoweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keinen anderen rechtlich zulässigen  Gründe für die Speicherung Ihrer personenbezogenen Daten haben (z.B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _vm._m(8),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt."
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Thomas Heimhalt (Externer Datenschutzbeauftragter)")]),
        _vm._v(" "),
        _c("p", [_vm._v("DATENSCHUTZ perfect GbR")]),
        _vm._v(" "),
        _c("p", [_vm._v("Wilhelm-Kolb-Str. 1a")]),
        _vm._v(" "),
        _c("p", [_vm._v("76187 Karlsruhe")]),
        _vm._v(" "),
        _c("p", [_vm._v("E-Mail: ym-datenschutz@yellowmap.de")]),
        _vm._v(" "),
        _vm._m(9),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt."
          )
        ]),
        _vm._v(" "),
        _vm._m(10),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, haben sie jederzeit das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, gegen die Verarbeitung ihrer personenbezogenen Daten Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling. die jeweilige Rechtsgrundlage, auf denen eine Verarbeitung beruht, entnehmen sie dieser Datenschutzerklärung. Wenn Sie Widerspruch einlegen, werden wir ihre betroffenen personenbezogenen Daten nicht mehr verarbeiten, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die ihre Interessen, Rechte und Freiheiten überwiegen oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen (Widerspruch nach art. 21 abs. 1 DSGVO)."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Werden ihre personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, so haben sie das Recht, jederzeit Widerspruch gegen die Verarbeitung Sie betreffender personenbezogener Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht. Wenn Sie widersprechen, werden Ihre personenbezogenen Daten anschließend nicht mehr zum Zwecke der Direktwerbung verwendet (Widerspruch nach art. 21 abs. 2 DSGVO)."
          )
        ]),
        _vm._v(" "),
        _vm._m(11),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe."
          )
        ]),
        _vm._v(" "),
        _vm._m(12),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist."
          )
        ]),
        _vm._v(" "),
        _vm._m(13),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“ wechselt und an dem Schloss-Symbol in Ihrer Browserzeile."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden."
          )
        ]),
        _vm._v(" "),
        _vm._m(14),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden."
          )
        ]),
        _vm._v(" "),
        _vm._m(15),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in folgenden Fällen:"
          )
        ]),
        _vm._v(" "),
        _vm._m(16),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats verarbeitet werden."
          )
        ]),
        _vm._v(" "),
        _vm._m(17),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor."
          )
        ]),
        _vm._v(" "),
        _c("h3", [
          _vm._v("\n\t\t\t\t3. Datenerfassung auf dieser Website\n\t\t\t")
        ]),
        _vm._v(" "),
        _vm._m(18),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Cookies haben verschiedene Funktionen. Die von dieser Webseite verwendeten Cookies sind technisch notwendig, da bestimmte Websitefunktionen ohne diese nicht funktionieren würden. Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs (notwendige Cookies) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Soweit Cookies von Drittunternehmen oder zu Analysezwecken eingesetzt werden, werden wir Sie hierüber im Rahmen dieser Datenschutzerklärung gesondert informieren und ggf. eine Einwilligung abfragen."
          )
        ]),
        _vm._v(" "),
        _vm._m(19),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wenn Sie uns per Kontaktformular Anfragen oder über das Registrierungsformular Registrierungen zukommen lassen, werden Ihre Angaben aus dem Formular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die von Ihnen in den Formularen eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage oder Ihres Vertrages). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt."
          )
        ]),
        _vm._v(" "),
        _vm._m(20),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt."
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("\n\t\t\t4. Analyse-Tools und Werbung\n\t\t\t")]),
        _vm._v(" "),
        _vm._m(21),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Diese Website benutzt den Open Source Webanalysedienst Matomo. Matomo verwendet Technologien, die die seitenübergreifende Wiedererkennung des Nutzers zur Analyse des Nutzerverhaltens ermöglichen (z.B. Device-Fingerprinting). Die durch Matomo erfassten Informationen über die Benutzung dieser Website werden auf unserem Server gespeichert. Die IP-Adresse wird vor der Speicherung anonymisiert. Wir nutzen Matomo ohne Cookie."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Mit Hilfe von Matomo sind wir in der Lage Daten über die Nutzung unserer Website durch die Websitebesucher zu erfassen und zu analysieren. Hierdurch können wir u. a. herausfinden, wann welche Seitenaufrufe getätigt wurden und aus welcher Region sie kommen. Außerdem erfassen wir verschiedene Logdateien (z.B. Referrer, verwendete Browser und Betriebssysteme) und können messen, ob unsere Websitebesucher bestimmte Aktionen durchführen (z.B. Klicks, Käufe u. Ä.)."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Sie können der vollkommenen pseudonymen Analyse Ihres Surfverhaltens durch Matomo widersprechen, indem Sie auf den nachfolgenden Link zur Austragung klicken: "
          ),
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.navigateTo(
                    "https://statistik.yellowmap.de/index.php?module=CoreAdminHome&action=optOut&language=de"
                  )
                }
              }
            },
            [_vm._v("Jetzt austragen!")]
          ),
          _vm._v(" "),
          _c("a", {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.navigateTo(
                  "https://statistik.yellowmap.de/index.php?module=CoreAdminHome&action=optOut&language=de"
                )
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die Nutzung dieses Analyse-Tools erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der anonymisierten Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren."
          )
        ]),
        _vm._v(" "),
        _vm._m(22),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wir hosten Matomo ausschließlich auf unseren eigenen Servern, sodass alle Analysedaten bei uns verbleiben und nicht weitergegeben werden."
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("\n\t\t\t\t5. Newsletter\n\t\t\t")]),
        _vm._v(" "),
        _vm._m(23),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass Sie der Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters einverstanden sind. Weitere Daten werden nicht bzw. nur auf freiwilliger Basis erhoben. Diese Daten verwenden wir ausschließlich für den Versand der angeforderten Informationen und geben diese nicht an Dritte weiter."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Die erteilte Einwilligung zur Speicherung der Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des Newsletters können Sie jederzeit widerrufen, etwa über den „Austragen“-Link im Newsletter. Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten Daten werden von uns bis zu Ihrer Austragung aus dem Newsletter bei uns bzw. dem Newsletterdiensteanbieter gespeichert und nach der Abbestellung des Newsletters aus der Newsletterverteilerliste gelöscht. Daten, die zu anderen Zwecken bei uns gespeichert wurden bleiben hiervon unberührt."
          )
        ]),
        _vm._v(" "),
        _vm._m(24),
        _vm._v(" "),
        _vm._m(25),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "YellowMap AG nutzt Inxmail für den Versand von Newslettern. Anbieterin ist die Inxmail GmbH, Wentzingerstr. 17, D-79106 Freiburg/Deutschland."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Inxmail ist ein Dienst, mit dem u.a. der Versand von Newslettern organisiert und analysiert werden kann. Die von Ihnen zum Zwecke des Newsletterbezugs eingegeben Daten werden auf den Servern von Inxmail in Deutschland gespeichert."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wenn Sie keine Analyse durch Inxmail wollen, müssen Sie den Newsletter abbestellen. Hierfür stellen wir in jeder Newsletternachricht einen entsprechenden Link zur Verfügung. Des Weiteren können Sie den Newsletter auch direkt auf der Website abbestellen."
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Datenanalyse durch Inxmail")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Mit Hilfe von Inxmail ist es uns möglich, unsere Newsletter-Kampagnen zu analysieren. So können wir z.B. sehen, ob eine Newsletter-Nachricht geöffnet und welche Links ggf. angeklickt wurden. Auf diese Weise können wir u.a. feststellen, welche Links besonders oft angeklickt wurden. Die Speicherung und Analyse der Empfängerreaktionen erfolgt dabei anonymisiert und kann daher nicht zu Ihnen zurückverfolgt werden."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Ausführliche Informationen zu den Funktionen von Inxmail entnehmen Sie folgendem Link:"
          )
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.navigateTo(
                  "https://www.inxmail.de/loesungen/e-mail-marketing"
                )
              }
            }
          },
          [_vm._v("https://www.inxmail.de/loesungen/e-mail-marketing")]
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.navigateTo("https://www.inxmail.de/datenschutz")
              }
            }
          },
          [_vm._v("https://www.inxmail.de/datenschutz")]
        ),
        _vm._v(" "),
        _c("p", [_vm._v("Rechtsgrundlage")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die Datenverarbeitung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt."
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Speicherdauer")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wenn sich Interessenten zu einem Newsletter anmelden, erhalten Sie diesen via Email."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Erfolgreiche Newsletter-Anmeldungen bleiben bis auf weiteres bestehen, solange bis der Interessent sich vom Newsletter abmeldet. Abmeldungen sind direkt aus jedem Newsletter möglich."
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", [
      _c("li", [
        _vm._v(
          "Der Schutz Ihrer Daten ist uns besonders wichtig. Deshalb erheben wir so wenig wie möglich Daten von Ihnen."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          'Wir tragen tragen die Siegel „fair.digital“ und „Software hosted in Germany"'
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Wir geben Ihre Daten nicht weiter, sie verbleiben bei uns in unseren deutschen ISO 27001 zertifizierten Rechenzentren."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Ihre IP-Adressen werden nicht dauerhaft gespeichert oder analysiert"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Wir nutzen keine fremdgehosteten Tools, die Ihre Daten an anderen Anbieter weiterleiten."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Zur anonymisierten Analyse des Nutzerverhaltens auf unserer Webseite verwenden wir Matomo ohne Cookies auf selbst gehosteten Systemen und mit anonymisierter IP-Adresse."
        )
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("Wir setzen nur technisch notwendige Cookies ein.")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "\n\t\t\t\tIhre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben."
      ),
      _c("br"),
      _vm._v(
        "\nAndere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.\n\t\t\t"
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "\n\t\t\t\tb)\tZur Erfüllung von vertraglichen Pflichten und vorvertraglichen Maßnahmen nach Art. 6 Abs. 1 Buchstabe b DSGVO "
      ),
      _c("br"),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("zur Durchführung unserer Verträge mit Ihnen")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "zur Durchführung von Maßnahmen und Tätigkeiten im Rahmen von vorvertraglichen Beziehungen"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "\n\t\t\t\tSie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.\n"
      ),
      _c("br"),
      _vm._v(
        "Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.\n\t\t\t"
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "\n\t\t\t\tBeim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit sogenannten Analyseprogrammen.\n\t\t\t"
      ),
      _c("br"),
      _vm._v(
        "Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerklärung.\n\t\t\t"
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "\n\t\t\t\tDie Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.\n\t\t\t\t"
      ),
      _c("br"),
      _vm._v(
        "\n\t\t\t\tWenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.\n\t\t\t\t"
      ),
      _c("br"),
      _vm._v(
        "\n\t\t\t\tWir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.\n\t\t\t"
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "\n\t\t\t\tDie verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:\n\t\t\t\t"
      ),
      _c("br")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v("YellowMap AG"),
      _c("br"),
      _vm._v("\n\t\t\t\tCAS Weg 1-5"),
      _c("br"),
      _vm._v("\n\t\t\t\t76131 Karlsruhe"),
      _c("br"),
      _vm._v("\n\t\t\t\tTelefon: +49 (0) 721 9638 600"),
      _c("br"),
      _vm._v("\n\t\t\t\tE-Mail: kontakt@yellowmap.de"),
      _c("br")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("strong", [
        _vm._v("Gesetzlich vorgeschriebener Datenschutz­beauftragter")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("strong", [
        _vm._v("Widerruf Ihrer Einwilligung zur Datenverarbeitung")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("strong", [
        _vm._v(
          "Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)"
        )
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("strong", [
        _vm._v("Beschwerde­recht bei der zuständigen Aufsichts­behörde")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Recht auf Daten­übertrag­barkeit")])])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("SSL- bzw. TLS-Verschlüsselung")])])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("strong", [_vm._v("Auskunft, Löschung und Berichtigung")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("strong", [_vm._v("Recht auf Einschränkung der Verarbeitung")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", [
      _c("li", [
        _vm._v(
          "Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt der Löschung die Einschränkung der Datenverarbeitung verlangen."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen."
        )
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Widerspruch gegen Werbe-E-Mails")])])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Cookies")])])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("strong", [_vm._v("Kontaktformular und Registrierung ")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("strong", [_vm._v("Anfrage per E-Mail, Telefon oder Telefax")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Matomo (ehemals Piwik)")])])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Hosting")])])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Newsletterdaten")])])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre E-Mail-Adresse bei uns bzw. dem Newsletterdiensteanbieter ggf. in einer Blacklist gespeichert, um künftige Mailings zu verhindern. Die Daten aus der Blacklist werden nur für diesen Zweck verwendet und nicht mit anderen Daten zusammengeführt. Dies dient sowohl Ihrem Interesse als auch unserem Interesse an der Einhaltung der gesetzlichen Vorgaben beim Versand von Newslettern (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO). Die Speicherung in der Blacklist ist zeitlich nicht befristet. "
      ),
      _c("strong", [
        _vm._v(
          "Sie können der Speicherung widersprechen, sofern Ihre Interessen unser berechtigtes Interesse überwiegen."
        )
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Newsletterversand mit Inxmail")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }